import styled from 'styled-components';

import { colors, transitions } from '../../../styles/theme';

interface Props {
  readonly alignSelf?: string;
}

const ActionButtonStyles = styled.a<Props>`
  font-family: 'Outfit', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
  color: ${colors('black.base')};
  text-decoration: none;
  cursor: pointer;
  grid-area: Action;
  align-self: ${({ alignSelf }: Props): string => alignSelf || 'center'};
  text-align: right;
  transition: ${transitions('fast')};
  text-underline-offset: 3px;

  &:visited,
  &:active {
    color: ${colors('primary.base')};
    transition: ${transitions('fast')};
  }

  &:hover {
    transition: ${transitions('fast')};
    color: ${colors('primary.base')};
    text-decoration: underline;
  }
`;

export default ActionButtonStyles;
